import { Typography, Box, IconButton, useTheme } from '@mui/material'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import Grid from '@mui/material/Grid'
import { useContext, useState } from 'react'
import ProfileContext from '../Context/ProfileContext'
import Image from 'next/image'

type Props = {}

const FrancoInfos: React.FC<Props> = () => {
  const theme = useTheme()
  const { basket, profile } = useContext(ProfileContext)

  const eligibleFranco = basket.eligible_for_franco

  const francoMagiq = basket.subtotal_franco_operator >= profile.globalFrancoMagic

  const [hidden, setHidden] = useState(false)

  if (hidden) return null

  if (!profile.globalFrancoMagic || !!profile?.groupAeliaStore) {
    return null
  }
  const message =
    'félicitations tous vos frais de livraisons sont maintenant supprimés !'.toLocaleUpperCase(
      'fr-FR'
    )
  if (!eligibleFranco) {
    return (
      <div className="p-1" style={{ backgroundColor: theme.palette.primary.light, color: theme.palette.primary.contrastText }}>
        <Grid container md={12} alignItems="center" justifyContent="center">
          <Typography className="justify-start text-[13px] rounded-[10px] font-bold" style={{ backgroundColor: theme.palette.primary.light }}>
            <Image
              src={'/images/icons/idea-16.png'}
              alt={t({
                id: 'web_commande_table_factures',
              })}
              width={16}
              height={16}
              style={{ marginRight: 4 }}
            />
            Votre panier LAP+ est dégroupé, vous n'êtes pas éligible au franco de port
          </Typography>
        </Grid>
      </div>
    )
  } else if (francoMagiq) {
    return (
      <div className="m-auto p-4 text-[22px]" style={{ backgroundColor: theme.palette.primary.light, color: theme.palette.primary.main }}>
        <Grid container md={12} alignItems="center" justifyContent="center">
          <Typography className="justify-start text-lg font-bold" style={{ backgroundColor: theme.palette.primary.light }}>
            {message}
          </Typography>
        </Grid>
      </div>
    )
  } else {
    return (
      <Box
        className="flex flex-col w-full rounded-2xl py-2.5 px-3.5 bg-white shadow-sm"
        style={{ border: `1px solid ${theme.palette.grey[300]}` }}
      >
        <div className="flex items-center justify-between cursor-pointer">
          <div className="flex items-center gap-2 flex-1">
            <LightbulbOutlinedIcon className="text-lg ml-0.5" style={{ color: theme.palette.grey[500] }} />
            <Typography className="text-sm font-semibold" style={{ color: theme.palette.grey[600] }}>
              Comment supprimer tous vos frais de livraison ?
            </Typography>
          </div>

          <IconButton
            aria-label="Fermer"
            size="small"
            className="p-1 hover:bg-transparent"
            style={{ color: theme.palette.grey[400] }}
            onClick={e => {
              e.stopPropagation()
              setHidden(true)
            }}
          ></IconButton>
        </div>

        <Typography className="mt-2 text-[13px] leading-snug" style={{ color: theme.palette.grey[700] }}>
          Atteignez un panier de {profile.globalFrancoMagic}€ tous vendeurs confondus, et tous vos
          frais de port seront supprimés.
          <br />
          <strong>Ou</strong> atteignez le(s) franco(s) des vendeurs de votre panier pour réduire ou
          supprimer vos frais de livraison.
        </Typography>
      </Box>
    )
  }
}
export default FrancoInfos
